// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import Rest, { headers, buildQuery, processStatus } from 'grommet/utils/Rest';
import { showLoader } from './status';
//let _host = 'http://localhost:3004';
let _host = '';
let _headers = {
    ...headers,
    'pragma': 'no-cache',
    'cache-control': 'no- cache'
    // 'X-API-Version': 200
};
let _webSocketUrl = undefined;

// XHR still for file upload progress
import request from 'superagent';
let _timeout = 20000;
let noOfRequests = 0;
// 20s, up from initial 10s due to use from slow mobile devices

// Configuration

export let pageSize = 20;
export let pollingInterval = 2000; // 2s
export let urlPrefix = '';

export function configure(options) {
    _host = options.host ? `http://${options.host}` : _host;
    pageSize = options.pageSize || pageSize;
    pollingInterval = options.pollingInterval || pollingInterval;
    _webSocketUrl = options.webSocketUrl || _webSocketUrl;
    urlPrefix = options.urlPrefix || urlPrefix;

    // initializeWatching(_webSocketUrl, _get);
}

export function updateHeaders(headers) {
    _headers = { ..._headers, ...headers };
    Rest.setHeaders(headers); ///
}

// Internal help/generic functions

function _get(uri, params) {
    const options = { method: 'GET', headers: _headers };
    const query = buildQuery(params);
    window.store.dispatch(showLoader(true));
    noOfRequests++;
    return fetch(`${_host}${urlPrefix}${uri}${query}`, options)
        .then(processStatus)
        .then((response) => {
            noOfRequests--;
            if (noOfRequests < 1) {
                window.store.dispatch(showLoader(false));
            }
            return response.json()
        })
        .catch(function (error) {
            noOfRequests--;
            window.store.dispatch(showLoader(false));
            // console.log('There has been a problem with your fetch operation: ' + error.message);
        });
}

function _post(uri, dataArg) {
    const data = (typeof dataArg === 'object') ?
        JSON.stringify(dataArg) : dataArg;
    const options = { method: 'POST', headers: _headers, body: data };
    window.store.dispatch(showLoader(true));
    noOfRequests++;
    return fetch(`${_host}${urlPrefix}${uri}`, options)
        .then(processStatus)
        .then(response => {
            noOfRequests--;
            if (noOfRequests < 1) {
                window.store.dispatch(showLoader(false));
            }
            return response.json();
        })
        .catch(function (error) {
            noOfRequests--;
            window.store.dispatch(showLoader(false));
            // console.log('There has been a problem with your fetch operation: ' + error.message);
        });
}

function _put(uri, dataArg) {
    const data = (typeof dataArg === 'object') ?
        JSON.stringify(dataArg) : dataArg;
    const options = { method: 'PUT', headers: _headers, body: data };
    window.store.dispatch(showLoader(true));
    noOfRequests++;
    return fetch(`${_host}${urlPrefix}${uri}`, options)
        .then(processStatus)
        .then(response => {
            noOfRequests--;
            if (noOfRequests < 1) {
                window.store.dispatch(showLoader(false));
            }
            return response.json();
        })
        .catch(function (error) {
            noOfRequests--;
            window.store.dispatch(showLoader(false));

            // console.log('There has been a problem with your fetch operation: ' + error.message);
        });
}

function _delete(uri) {
    const options = { method: 'DELETE', headers: _headers };
    window.store.dispatch(showLoader(true));
    noOfRequests++;
    return fetch(`${_host}${urlPrefix}${uri}`, options)
        .then(processStatus)
        .then(response => {
            noOfRequests--;
            if (noOfRequests < 1) {
                window.store.dispatch(showLoader(false));
            }
            return response.json();
        })
        .catch(function (error) {
            window.store.dispatch(showLoader(false));
            // console.log('There has been a problem with your fetch operation: ' + error.message);
        });
}

export function head(url, params) {
    const query = buildQuery(params);
    const options = { method: 'HEAD', headers: _headers };
    return fetch(`${_host}${urlPrefix}${url}${query}`, options);
}

// Index

export function postLogin(userName, password) {
    const params = { username: userName, password: password };
    return _post('/api/user/login', params);
}

export function getTwigs(siteName) {
    let url = '/api/stem/?isEnabled=true';
    url = siteName ? url + '&siteName=' + encodeURIComponent(siteName) : url;

    return _get(url);
}

export function getTwigChart(twigId, fromDate, toDate, pageNo) {
    let params = {
        fromDate: fromDate,
        toDate: toDate,
        pageNo: pageNo
    }
    let url = '/api/data/stem/' + twigId;
    // url = fromDate ? url + '?fromDate=' + fromDate : url;
    url = url + '?fromDate=' + fromDate;
    url = toDate ? url + '&toDate=' + toDate : url;
    // url = url + '&pageNo=' + pageNo;
    return _get(url);
}

export function getSites() {
    return _get('/api/site');
}

export function getUserProfile(userId) {
    return _get('/api/user/' + userId);
}

export function updateSite(siteId, data) {
    return _put('/api/site/' + siteId, data)
}

export function addSite(data) {
    return _post('/api/site', data)
}

export function getValuesFromParseClass(parseClass, hasUser) {
    return _get('/api/objects/' + parseClass + '/options?isUserRelatedOptions=' + hasUser)
}

export function updateTwig(twigId, twigObj) {
    return _put('/api/stem/' + twigId, twigObj)
}

export function updateProfileApi(userId, profileData) {
    return _put('/api/user/' + userId, profileData)
}

export function postLogout() {
    return _post('/api/user/logout', {});
}

export function getAlerts(twigId) {
    return _get('/api/alert/twig/' + twigId);
}

export function saveAlert(alertData) {
    return _post('/api/alert', alertData);
}

export function updateAlert(alertId, alertData) {
    return _put('/api/alert/' + alertId, alertData)
}

export function deleteAlert(alertId) {
    return _delete('/api/alert/' + alertId);
}

export function addStemID(stemId) {
    return _get('/api/stem/' + stemId);
}

export function createStem(stemObj) {
    return _post('/api/stem', stemObj);
}

export function getUserPreferences() {
    return _get('/api/user/preference');
}

export function saveUserPreferences(saveObj) {
    return _post('/api/user/preference', saveObj);
}
// ******************************















































export function getItems(params) {
    return _get('/rest/index/resources', params);
}

export function getSearchSuggestions(text) {
    const params = { start: 0, count: Math.min(10, pageSize), query: text };
    return _get('/rest/index/search-suggestions', params);
}

// Item

export function getItem(uri) {
    return _get(uri);
}

export function postItem(item) {
    return _post(`/rest/${item.category}`, item).then(refresh);
}

export function putItem(item) {
    return _put(item.uri, item).then(refresh);
}

export function deleteItem(uri) {
    return _delete(uri).then(refresh);
}

// Watching

const watches = {};

function normalizeAggregate(result, handler) {
    handler(result[0].counts); // for now
}

export function watchItems(name, params, successHandler, errorHandler) {
    stopWatching(name, true);
    const query = buildQuery(params);
    const uri = `/rest/index/resources${query}`;
    const watcher = watch(uri, successHandler, errorHandler);
    watches[name] = watcher;
}

export function watchItem(name, uri, successHandler, errorHandler) {
    stopWatching(name, true);
    const watcher = watch(uri, successHandler, errorHandler);
    watches[name] = watcher;
}

export function watchAggregate(name, params, successHandler, errorHandler) {
    stopWatching(name, true);
    const query = buildQuery(params);
    const uri = `/rest/index/resources/aggregated${query}`;
    const watcher = watch(uri,
        (result) => normalizeAggregate(result, successHandler),
        errorHandler);
    watches[name] = watcher;
}

export function watchAssociated(name, uriArg, successHandler, errorHandler) {
    stopWatching(name, true);
    const uri = `/rest/index/trees/aggregated${uriArg}`;
    const watcher = watch(uri, successHandler, errorHandler);
    watches[name] = watcher;
}

export function stopWatching(name, quiet) {
    if (watches[name]) {
        disregard(watches[name]);
        delete watches[name];
    } else if (!quiet) {
        console.warn('stopWatching undefined watcher', name);
    }
}

export function refresh(response) {
    refreshWatching();
    return response;
}

// Status

export function getStatus() {
    return _get('/rest/status');
}

// Session



export function postResetPassword(userName, password) {
    const params = { userName: userName, password: password };
    return _post('/rest/reset-password', params);
}



export function getRole() {
    return _get('/rest/authz/role');
}

export function getSession() {
    return _get('/rest/sessions');
}

// Settings

export function getSettings() {
    return _get('/rest/settings');
}

export function getCertificate(params) {
    return _get('/rest/settings', params);
}

export function postConnection(address, userName, password) {
    // We do a post to avoid sending credentials as more visible parameters
    const params = { address: address, userName: userName, password: password };
    return _post('/rest/connection', params);
}

export function getDirectorySearch(address, baseDn, searchText) {
    const params = { address: address, baseDn: baseDn, searchText: searchText };
    return _get('/rest/directory/search', params);
}

export function putSettings(settings) {
    return _put('/rest/settings', settings);
}

// export function postSettings (data) {
//   // This is the Restore action
//   let headers = {..._headers};
//   delete headers['Content-Type'];
//   const options = { method: 'POST', headers: headers, body: data };
//   return fetch(`${_host}${urlPrefix}/rest/settings`, options)
//   .then(processStatus)
//   .then(response => response.json());
// }

export function getSoftware() {
    return _get('/rest/update');
}

export function postSoftwareUpload(file, progressHandler, handler) {
    // We need to keep using XHR until fetch() has a way to track long upload
    // progress. Since we don't do file uploading from mobile platforms,
    // we can get away with this.
    request.post(`${_host}${urlPrefix}/rest/update/upload`)
        .timeout(_timeout)
        // remove Content-Type since we're sending a file
        .set({ ..._headers, "Content-Type": undefined })
        .attach('file', file)
        .on('progress', progressHandler)
        .end(handler);
}

export function postSoftwareUpdate() {
    return _post('/rest/update');
}

export function delSoftware() {
    return _delete('/rest/update');
}

export function postRestart() {
    return _post('/rest/restart');
}

export function getBackup() {
    return _get('/rest/backup');
}

export function postBackup() {
    return _post('/rest/backup');
}

export function delBackup() {
    return _delete('/rest/backup');
}

export function getSupport() {
    return _get('/rest/support');
}

export function postSupport() {
    return _post('/rest/support');
}

export function delSupport() {
    return _delete('/rest/support');
}

// Image

export function postImage(image, file, progressHandler, handler) {
    // We need to keep using XHR until fetch() has a way to track long upload
    // progress. Since we don't do file uploading from mobile platforms,
    // we can get away with this.
    request.post(`${_host}${urlPrefix}/rest/images`)
        .timeout(_timeout)
        // remove Content-Type since we're sending a file
        .set({ ..._headers, "Content-Type": undefined })
        .field('name', image.name)
        .attach('file', file)
        .on('progress', progressHandler)
        .end(handler);
}

export function putImage(image, file, progressHandler, handler) {
    // We need to keep using Rest until fetch() has a way to track long upload
    // progress. Since we don't do file uploading from mobile platforms,
    // we can get away with this.
    request.put(`${_host}${urlPrefix}${image.uri}`)
        .timeout(_timeout)
        .set({ ..._headers, "Content-Type": undefined })
        .field('uri', image.uri)
        .field('name', image.name)
        .field('status', image.status)
        .field('state', image.state)
        .field('created', image.created)
        .attach('file', file)
        .on('progress', progressHandler)
        .end(handler);
}

// Virtual Machine

export function postPowerOnVm(uri) {
    return _post(`${uri}/on`).then(refresh);
}

export function postPowerOffVm(uri) {
    return _post(`${uri}/off`).then(refresh);
}

export function postRestartVm(uri) {
    return _post(`${uri}/restart`).then(refresh);
}

// Route

export function postRoute(route) {
    return _post(`/rest/route`, route);
}

// subscription

export function initializeStripe(){
    return _get(`/api/stripe/initializeStripe`);
}

export function getSubscription(stemId, showPlans){
    return _get(`/api/subscription/getSubscription/${stemId}/${showPlans}`);
}


export function createStripeSubscription(data){
    return _post(`/api/subscription/createSubscription`, data);
}

export function validateCoupon(coupon){
    return _get(`/api/subscription/validateCoupon/${coupon}`);
}

export function getSubscriptionDetails () {
    return _get(`/api/subscription/getAuditdata`);
}

export function cancelStripeSubscription (data) {
    return _post(`/api/subscription/cancelSubscription`, data);
}

export function getCustomerCard() {
    return _get(`/api/subscription/getCustomerCard`);
}

//sign up

export function register (data) {
    return _post(`/api/user/register`, data);
}

export function resetPassword(data) {
    return _post('/api/user/resetPassword', data);
}



// WEBPACK FOOTER //
// ./src/js/actions/Api.js